import styled from "styled-components";

const PageSubtitle = styled.h1`
  margin: 0px;
  bottom: 0;
  font-size: 24px;
  font-weight: 400;
  font-family: ${(p) => p.theme.fontFamily};
  display: ${(p) => (p?.style?.display ? p?.style?.display : "block")};
  color: ${(p) => (p.color ? p.color : p.theme.colors.primary4)};
  font-size: ${(p) => (p?.style?.fontSize ? p.style.fontSize : "20px")};
  margin-bottom: 6px;
`;

export default PageSubtitle;
